import RequestHandler from "./request-handler";
class FotavOutputTableService {
    constructor() {
        this.path = "FotavOutputTable";
        if (FotavOutputTableService.instance) {
            return FotavOutputTableService.instance;
        }
        FotavOutputTableService.instance = this;
        return this;
    }
    async get() {
        return await RequestHandler.get(this.path);
    }
    async getCustomersByDateRange(data) {
        return await RequestHandler.getWithParams(this.path + '/getCustomers', data);
    }
    async insert(data) {
        return await RequestHandler.post(this.path, data);
    }
    async delete(id) {
        return await RequestHandler.delete(this.path, id);
    }
    async download(data) {
        return await RequestHandler.download(this.path, data);
    }
    async generateReport(data) {
        return await RequestHandler.generateReport(this.path, data);
    }
}
const instance = new FotavOutputTableService();
export default instance;